import React from 'react';
import toast from 'react-hot-toast';
import { Transition } from '@headlessui/react';

import { Icon } from '../components/Icons';

const useToast = () => {
  const handleShowToast = (
    message = '',
    iconName = '',
    designSpecs = { className: '', showClose: true, duration: 2000 }
  ) => {
    toast.custom(
      (t) => (
        <Transition
          show={true}
          enter="ltw-transform ltw-transition ltw-duration-[400ms]"
          enterFrom="ltw-opacity-0 ltw-rotate-[-120deg] ltw-scale-50"
          enterTo="ltw-opacity-100 ltw-rotate-0 ltw-scale-100"
          leave="ltw-transform ltw-duration-200 ltw-transition ltw-ease-in-out"
          leaveFrom="ltw-opacity-100 ltw-rotate-0 ltw-scale-100"
          leaveTo="ltw-opacity-0 ltw-scale-95"
        >
          <div
            className={`ltw-bg-black-one ltw-px-21px ltw-py-19px ltw-shadow-toast ltw-rounded-lg ltw-min-w-300px ${designSpecs.className}`}
          >
            <div className="ltw-flex ltw-items-center ltw-justify-between">
              <div className="ltw-flex ltw-items-center ltw-gap-9px">
                <Icon height="12" name={iconName} width="12" />
                <h1 className="ltw-text-14 ltw-antialiased ltw-font-medium ltw-text-white ltw-leading-1694">
                  {message}
                </h1>
              </div>
              {designSpecs.showClose && (
                <Icon
                  className="ltw-fill-current ltw-cursor-pointer ltw-text-white"
                  height="12"
                  name="close"
                  onClick={() => toast.dismiss(t.id)}
                  width="12"
                />
              )}
            </div>
          </div>
        </Transition>
      ),
      { duration: designSpecs.duration }
    );
  };

  return { handleShowToast };
};

export default useToast;
